import { httpV1 as http } from '../api';

export async function getCategories(params) {
  const { data: response } = await http.get('/cgv/get-vehicle-categories', { params });
  return response?.data.map(({ name, id: value }) => ({ name, value }));
}

export async function getBrands(category) {
  const { data: response } = await http.get('cgv/get-vehicle-brands', { params: { category } });
  return response?.data.map(({ name, id: value }) => ({ name, value }));
}

export async function getModels({ year, brand }) {
  const { data: response } = await http.get('/cgv/get-vehicle-models', { params: { brand, year } });
  return response?.data.map(({ name, id: value }) => ({ name, value }));
}

export async function getVersions({ year, brand, model }) {
  const { data: response } = await http.get('/cgv/get-vehicle-versions', { params: { year, brand, model } });
  return response?.data.map(({ name, id: value }) => ({ name, value }));
}

export async function getVehicleByLicense({ license }) {
  return http.get(`/cgv/get-vehicle-by-license?license=${license}`);
}
